import React from 'react';

import clsx from 'clsx';

import * as classes from './ControlBlock.module.css';

const ControlBlock = ({
    innerEditor,
    parentId,
    id,
    value,
    ...props
}) => {

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`${id}-block-constant`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div
                data-parentId={parentId}
                data-id={id}
                id={`${id}-control-block`}
                className={classes.ControlBlock}
            >
                <div className={classes.ControlContainer}>
                    <div className={classes.LabelContainer}>
                        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className={classes.Label}>Control</label>
                        { /* eslint-disable-next-line jsx-a11y/no-onchange */}
                        <select data-select-id={id} defaultValue={value} className={classes.Select}>
                            <option>=</option>
                            <option>!=</option>
                            <option>{'<'}</option>
                            <option>{'<='}</option>
                            <option>{'>'}</option>
                            <option>{'>='}</option>
                        </select>
                    </div>
                </div>
                <span
                    id={`${id}-delete`}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default ControlBlock;
